import { type I18nResources } from '@cms/i18n/shared';

import { I18N_RESOURCES as I18N_RESOURCES_NL_NL } from './resources.nl_NL';

export const I18N_RESOURCES: I18nResources = {
    nl_NL: I18N_RESOURCES_NL_NL,
};
